export function minuteOfDayToTimeFilter() {
    return (minuteOfDay: number) => {
        const minuteOfDayNumber: number = Number(minuteOfDay);

        const hour = Math.floor(minuteOfDayNumber / 60);
        const minute = Math.floor(minuteOfDayNumber % 60);

        const hourString = (hour < 10) ? `0${hour}` : `${hour}`;
        const minuteString = (minute < 10) ? `0${minute}` : `${minute}`;

        return `${hourString}:${minuteString}`;
    }
}
